module.exports = __webpack_public_path__ + "static/img/ACC3.91fa4608.png";